import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header style={styles.header}>
      <div style={styles.navWrapper}>
        <div style={styles.logoContainer}>
          <img 
            src="https://customer-assets.emergentagent.com/job_redcross-funding/artifacts/ikgacwfy_IMG_9082.jpeg" 
            alt="WAHR Logo" 
            style={styles.logo}
          />
        </div>
        
        {/* Desktop Navigation */}
        <nav style={styles.desktopNav}>
          <button onClick={() => scrollToSection('about')} style={styles.navLink}>Über das Coaching</button>
          <button onClick={() => scrollToSection('services')} style={styles.navLink}>Leistungen</button>
          <button onClick={() => scrollToSection('testimonials')} style={styles.navLink}>Referenzen</button>
          <button onClick={() => scrollToSection('contact')} style={styles.navLink}>Kontakt</button>
          <button onClick={() => scrollToSection('booking')} className="btn-primary" style={styles.ctaButton}>
            Termin buchen
          </button>
        </nav>
        
        {/* Mobile Menu Button */}
        <button 
          style={styles.mobileMenuButton} 
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={24} color="white" /> : <Menu size={24} color="white" />}
        </button>
      </div>
      
      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div style={styles.mobileNav}>
          <button onClick={() => scrollToSection('about')} style={styles.mobileNavLink}>Über das Coaching</button>
          <button onClick={() => scrollToSection('services')} style={styles.mobileNavLink}>Leistungen</button>
          <button onClick={() => scrollToSection('testimonials')} style={styles.mobileNavLink}>Referenzen</button>
          <button onClick={() => scrollToSection('contact')} style={styles.mobileNavLink}>Kontakt</button>
          <button onClick={() => scrollToSection('booking')} className="btn-primary" style={{...styles.ctaButton, width: '100%', marginTop: '12px'}}>
            Termin buchen
          </button>
        </div>
      )}
    </header>
  );
};

const styles = {
  header: {
    position: 'fixed',
    top: '16px',
    left: 0,
    right: 0,
    zIndex: 9999,
    padding: '0 12px',
  },
  navWrapper: {
    maxWidth: '1440px',
    margin: '0 auto',
    background: 'var(--brand-dark)',
    borderRadius: '25px',
    padding: '12px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0 2px 12px rgba(28, 46, 82, 0.2)',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    height: '40px',
    width: 'auto',
  },
  desktopNav: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
  },
  navLink: {
    color: 'white',
    textDecoration: 'none',
    fontSize: '16px',
    fontWeight: '500',
    padding: '8px 16px',
    borderRadius: '20px',
    transition: 'all 0.2s ease',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
  },
  ctaButton: {
    marginLeft: '8px',
  },
  mobileMenuButton: {
    display: 'none',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
  },
  mobileNav: {
    maxWidth: '1440px',
    margin: '8px auto 0',
    background: 'var(--brand-dark)',
    borderRadius: '20px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  mobileNavLink: {
    color: 'white',
    textDecoration: 'none',
    fontSize: '16px',
    fontWeight: '500',
    padding: '12px 16px',
    borderRadius: '12px',
    transition: 'all 0.2s ease',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
  },
};

// Add media query styles
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @media (max-width: 781px) {
    nav[style*="display: flex"] {
      display: none !important;
    }
    button[style*="mobileMenuButton"] {
      display: block !important;
    }
  }
  
  @media (min-width: 782px) {
    div[style*="mobileNav"] {
      display: none !important;
    }
  }
  
  header button:hover {
    background: rgba(255, 255, 255, 0.1) !important;
  }
`;
document.head.appendChild(styleSheet);

export default Header;